window.slate = window.slate || {};
window.theme = window.theme || {};




/* 2026-10-13: removed the legacy /collections/elizabethsulcer -> /pages/elizabeth-sulcer-capsule JS redirect.
   That page is unpublished and 301s back to the collection, so every load (and every
   /collections/elizabethsulcer/products/* page) ping-ponged between the two and flickered. */

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on('click', function (evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }



};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

/* 2026-10-13: $ is gone by now (jQuery.noConflict(true), see layout/theme.liquid + snippets/newsletter-popup.liquid), so everything
   below used to throw "Cannot read properties of undefined (reading 'extend')" on every page. Guarded: same behaviour (the rest of this
   file stays dead), no error. DO NOT make $ available just to silence this - it would resurrect the old handlers (double-bound #Hamburger).
   Rollback: recall-backups/2026-10-13-extend-error/ROLLBACK.sh */
if (typeof $ !== 'undefined') {
slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function (index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount_no_decimals}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $('.swatch input').on('click', function () {
      let val = $(this).val();
      let $selector_wrapper = $(this).closest('.selector-wrapper');
      let $select = $selector_wrapper.find('[data-single-option-selector]');
      $select.find(`option[value="${val}"]`).prop('selected', true);
      $select.trigger('change');
    });

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
      // BEGIN SWATCHES
      var selector = this.originalSelectorId;
      if (variant) {
        var form = $(selector).closest('form');
        for (var i = 0, length = variant.options.length; i < length; i++) {
          var radioButton = form.find('.swatch[data-option-index="' + (i + 1) + '"] :radio[value="' + variant.options[i] + '"]');
          if (radioButton.length > 0) {
            radioButton.get(0).checked = true;
          }
        }
      }
      // END SWATCHES
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });

      /* 
      // Update Easify canvas with new variant image
      this._updateEasifyCanvas(variant);
      */
    },

    /**
     * Update Easify Product Options canvas with variant image
     *
     * @param {object} variant - Currently selected variant
     */
    _updateEasifyCanvas: function (variant) {
      /*
      if (!variant || !variant.featured_image) {
        return;
      }

      // Check if Konva (Easify canvas) exists
      if (window.Konva && window.Konva.stages && window.Konva.stages[0]) {
        var stage = window.Konva.stages[0];
        var backgroundImage = stage.findOne('#tpo_custom_background_image');
        
        if (backgroundImage) {
          var img = new Image();
          img.crossOrigin = 'Anonymous';
          img.src = variant.featured_image.src;
          img.onload = function() {
            backgroundImage.setAttrs({
              image: img,
              width: img.naturalWidth,
              height: img.naturalHeight
            });
            
            // Update stage dimensions
            stage.setAttrs({
              width: img.naturalWidth,
              height: img.naturalHeight,
              initialWidth: img.naturalWidth,
              initialHeight: img.naturalHeight
            });
            
            // Resize canvas to fit container
            var container = document.querySelector('.tpo_canvas_builder');
            if (container) {
              var containerWidth = container.offsetWidth;
              var scale = containerWidth / img.naturalWidth;
              stage.width(containerWidth);
              stage.height(img.naturalHeight * scale);
              stage.scale({ x: scale, y: scale });
            }
            
            stage.batchDraw();
            
            // Dispatch event for Easify
            document.dispatchEvent(new CustomEvent('easify:variant-image-changed', {
              bubbles: true,
              detail: { variant: variant }
            }));
          };
        }
      }
      */
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
      // Also update hidden input with data-product-variant-id
      var $hiddenInput = this.$container.find('[data-product-variant-id]');
      if ($hiddenInput.length) {
        $hiddenInput.val(variant.id);
      }
      // Update add to cart button data attribute
      var $addToCart = this.$container.find('[data-add-to-cart]');
      if ($addToCart.length) {
        $addToCart.attr('data-cart-add', variant.id);
      }
    }
  });

  return Variants;
})();


/*================ Sections ================*/
theme.Cart = (function () {

  const $window = $(window);

  if ($('.template-cart').length) {
    Cart();
  }

  function Cart() {
    console.log('cart found')
    $(document).on('cart.requestComplete', function (event, cart) {
      updateCart(cart);
    });
  }

  function updateCart(cart) {
    //loop through items and update cart
    console.log(cart);

    // Format money helper function
    function formatMoney(cents) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = theme.moneyFormat || '${{amount}}';

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision || 2;
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);
    }

    $('.cart-subtotal div p').html(formatMoney(cart.total_price));
    for (var i = 0; i < cart.items.length; i++) {
      let $td = $('.cart-form .responsive-table-row').eq(i);
      //format money
      $td.find('.money').parent().html(formatMoney(cart.items[i].line_price));
      if (cart.items[i].quantity > 0) {
        $td.find('td[data-label="Quantity"] span').text(cart.items[i].quantity);
        let m = cart.items[i].quantity - 1 > 1 ? cart.items[i].quantity - 1 : 1;
        $td.find('.quantity-minus').attr('data-cart-quantity', m);
        $td.find('.quantity-text').text(cart.items[i].quantity);
        $td.find('.quantity-plus').attr('data-cart-quantity', cart.items[i].quantity + 1);
      } else {
        $td.remove();
      }

    }
  }

  return Cart;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function () {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateVariantSwatches.bind(this));

    $(document).on('cart.requestComplete', function (event, cart) {
      swapAddToCart();
    });

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      this.settings.imageSize = '1024x';
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }


    $(window).on('scroll', detectProductContainerScroll).on('resize', detectMobileSlideshow)
    detectMobileSlideshow();
    accordions();
    detectProductContainerScroll();
    setZoom();
    //$(window).trigger('scroll');

    /*
    // Initialize Easify canvas with selected variant image on page load
    this._initEasifyCanvasWithVariant();
    */
  }

  function setZoom() {
    if ($(window).width() >= 1024)
      $('.product-images li').on('click', function () {
        $('body').toggleClass('zoomed');
        $(window).trigger('resize scroll');
        //console.log($('.lazyloaded'))
        lazySizes.autoSizer.checkElems();
        setTimeout(function () { $(window).trigger('resize scroll') }, 1000);
        setTimeout(function () { $(window).trigger('resize scroll') }, 1500);
        if ($('body').hasClass('zoomed')) {
          let $li = $(this);
          $('.product-images li').hide();
          $li.show();
          $('.product-container-left').scrollTop(0);
        } else {
          $('.product-images li').show();
          $('.product-container-left').scrollTop(0);
        }

      });
  }

  function detectMobileSlideshow() {
    let $pi = $('.product-container-left .product-images:not(.customize)');
    if ($(window).width() < 1024) {
      if (!$pi.hasClass('slick-initialized')) {
        $pi.slick({
          dots: true,
          arrows: false,
        });
      }
    } else {
      if ($pi.hasClass('slick-initialized')) {
        $pi.slick('unslick');
      }
    }

  }

  function accordions() {
    $('.accordion-trigger').on('click', function (e) {
      e.preventDefault();
      $(this).parent().parent().find('.accordion-content').slideUp();
      $(this).next().stop().slideToggle();
    });
    $('.accordion-content').find('a').attr('target', '_blank');
  }

  function detectProductContainerScroll() {
    // Temporarily disabled to fix layout issues
    // The abs class was causing layout problems with Easify options
    return;
  }

  function swapAddToCart() {
    $(selectors.addToCartText, this.$container).html(theme.strings.added);
    setTimeout(function () {
      $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
    }, 500);
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;

      // console.log(variant);

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
        $(selectors.addToCart, this.$container).attr('data-cart-add', variant.id);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');

        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        $(selectors.addToCart, this.$container).attr('data-cart-add', variant.id);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      $('body, html').stop().animate({ scrollTop: 0 });
      this.$featuredImage.attr('src', sizedImgUrl);
      /*data-srcset="//cdn.shopify.com/s/files/1/0038/9313/3385/products/58_180x.jpg?v=1543518446 180w, //cdn.shopify.com/s/files/1/0038/9313/3385/products/58_360x.jpg?v=1543518446 360w, //cdn.shopify.com/s/files/1/0038/9313/3385/products/58_540x.jpg?v=1543518446 540w, //cdn.shopify.com/s/files/1/0038/9313/3385/products/58_720x.jpg?v=1543518446 720w, //cdn.shopify.com/s/files/1/0038/9313/3385/products/58_900x.jpg?v=1543518446 900w, //cdn.shopify.com/s/files/1/0038/9313/3385/products/58_1080x.jpg?v=1543518446 1080w, //cdn.shopify.com/s/files/1/0038/9313/3385/products/58_1296x.jpg?v=1543518446 1296w, //cdn.shopify.com/s/files/1/0038/9313/3385/products/58_1512x.jpg?v=1543518446 1512w, //cdn.shopify.com/s/files/1/0038/9313/3385/products/58_1728x.jpg?v=1543518446 1728w, //cdn.shopify.com/s/files/1/0038/9313/3385/products/58_1944x.jpg?v=1543518446 1944w, //cdn.shopify.com/s/files/1/0038/9313/3385/products/58_2160x.jpg?v=1543518446 2160w, //cdn.shopify.com/s/files/1/0038/9313/3385/products/58_2376x.jpg?v=1543518446 2376w, //cdn.shopify.com/s/files/1/0038/9313/3385/products/58_2400x.jpg?v=1543518446 2400w"
      */
      var img_180 = sizedImgUrl.split('1024x').join('180x');
      var img_360 = sizedImgUrl.split('1024x').join('360x');
      var img_540 = sizedImgUrl.split('1024x').join('540x');
      var img_720 = sizedImgUrl.split('1024x').join('720x');
      var img_900 = sizedImgUrl.split('1024x').join('900x');
      var img_1080 = sizedImgUrl.split('1024x').join('1080x');
      var img_1296 = sizedImgUrl.split('1024x').join('1296x');
      var img_1512 = sizedImgUrl.split('1024x').join('1512x');
      var img_1728 = sizedImgUrl.split('1024x').join('1728x');
      var img_1944 = sizedImgUrl.split('1024x').join('1944x');
      var img_2160 = sizedImgUrl.split('1024x').join('2160x');
      var img_2376 = sizedImgUrl.split('1024x').join('2376x');
      var img_2400 = sizedImgUrl.split('1024x').join('2400x');

      var src = `${img_180} 180w, ${img_360} 360w, ${img_540} 540w, ${img_720} 720w, ${img_900} 900w, ${img_1080} 1080w, ${img_1296} 1296w, ${img_1512} 1512w, ${img_1728} 1728w, ${img_1944} 1944w, ${img_2160} 2160w, ${img_2376} 2376w, ${img_2400} 2400w`;
      this.$featuredImage.attr('data-srcset', src);
      this.$featuredImage.attr('srcset', src);

      // Trigger mutation for Easify canvas observer
      var $wrapper = this.$featuredImage.closest('[data-product-image-wrapper]');
      if ($wrapper.length) {
        // Force mutation observer to detect change
        $wrapper.attr('data-variant-id', variant.id);
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },

    /**
     * Keep variant swatch UI in sync with selected variant
     * (single source of truth inside theme.js instead of external scripts)
     */
    updateVariantSwatches: function () {
      var $swatches = this.$container.find('.product-variants-wrapper .swatch input[type="radio"]');
      if (!$swatches.length) return;

      $swatches.each(function () {
        var $input = $(this);
        var $label = $input.closest('label');
        if (!$label.length) return;

        if (this.checked) {
          $label.addClass('is-selected');
        } else {
          $label.removeClass('is-selected');
        }
      });
    },

    /**
     * Initialize Easify canvas with the selected variant's image on page load
     */
    _initEasifyCanvasWithVariant: function () {
      /*
      var self = this;
      var currentVariant = this.variants.currentVariant;
      
      if (!currentVariant || !currentVariant.featured_image) {
        return;
      }

      // Wait for Easify to initialize its canvas
      var checkInterval = setInterval(function() {
        if (window.Konva && window.Konva.stages && window.Konva.stages[0]) {
          clearInterval(checkInterval);
          
          // Small delay to ensure Easify has fully rendered
          setTimeout(function() {
            var stage = window.Konva.stages[0];
            var backgroundImage = stage.findOne('#tpo_custom_background_image');
            
            if (backgroundImage) {
              var img = new Image();
              img.crossOrigin = 'Anonymous';
              img.src = currentVariant.featured_image.src;
              img.onload = function() {
                backgroundImage.setAttrs({
                  image: img,
                  width: img.naturalWidth,
                  height: img.naturalHeight
                });
                
                stage.setAttrs({
                  width: img.naturalWidth,
                  height: img.naturalHeight,
                  initialWidth: img.naturalWidth,
                  initialHeight: img.naturalHeight
                });
                
                // Resize canvas to fit container
                var container = document.querySelector('.tpo_canvas_builder');
                if (container) {
                  var containerWidth = container.offsetWidth;
                  var scale = containerWidth / img.naturalWidth;
                  stage.width(containerWidth);
                  stage.height(img.naturalHeight * scale);
                  stage.scale({ x: scale, y: scale });
                }
                
                stage.batchDraw();
              };
            }
          }, 500);
        }
      }, 100);

      // Clear interval after 10 seconds if Konva doesn't load
      setTimeout(function() {
        clearInterval(checkInterval);
      }, 10000);
      */
    }
  });

  return Product;
})();

theme.Video = (function () {

  const $window = $(window),
    $header = $('div[data-section-id="header"]'),
    $block = $('.spread-slideshow-block');

  var $heroVideo = $('.hero-video');
  if ($('.hero-video').length) {
    //Video();
  }

  if ($('.hero-video iframe').length > 0) {
    console.log('iframe embed detected');
    let $iframe = $('.hero-video iframe');
    $iframe.css('height', $iframe.width() * .5625);
    $window.on('resize', function () {
      $iframe.css('height', $iframe.width() * .5625);
    });

    setTimeout(function () {
      $(window).trigger('resize');
    }, 400);
  }

  function Video() {
    console.log('video found');
    //$window.on('scroll', throttle(watchScroll, 100));
    $heroVideo.on('click', function () {
      $('body, html').animate({ scrollTop: $heroVideo.outerHeight() })
    })
  }

  function watchScroll() {
    let st = $window.scrollTop();
    if (st > $heroVideo.outerHeight() - $header.height()) {
      $header.removeClass('white');
    } else {
      $header.addClass('white');
    }

  }

  return Video;
})();

theme.Header = (function () {

  const $header = $('header'),
    $headerContainer = $('[data-section-type="header-section"]'),
    $hamburger = $('#Hamburger'),
    $body = $('body'),
    $window = $(window),
    $block = $('.left-spread-container');

  var scrollTimer;

  if ($header.length) {
    Header();
  }

  scroll();

  function Header() {
    $hamburger.on('click', function () {
      $body.toggleClass('mobile-menu-shown').removeClass('search-active');
    });
  }

  function scroll() {
    $window.on('scroll', throttle(watchScroll));
  }

  function watchScroll() {
    $body.addClass('scrolling');
    clearTimeout(scrollTimer);
    let st = $window.scrollTop();

    scrollTimer = setTimeout(function () {
      $body.removeClass('scrolling');
    }, 250);

    if ($block.length > 0)
      if ($window.width() < 1024) {
        if (st > $block.position().top) {
          $headerContainer.addClass('white');
        } else {
          $headerContainer.removeClass('white');
        }
      }
  }

  return Header;
})();

theme.Newsletter = (function () {

  const $newsletter = $('#NewsletterPopup'),
    $newsletterModule = $('#NewsletterModule'),
    $close = $newsletter.find('#CloseNewsletterPopup'),
    $moduleMsg = $('.newsletter-module-message')

  if ($newsletter.length) {
    Newsletter();
  }
  if ($newsletterModule.length) {
    NewsletterModule();
  }

  function Newsletter() {
    //cookie not found so display newsletter
    if (Cookies.get('newsletter') != 'closed') {
      $newsletter.css('display', '');
      $newsletter.delay(200).slideDown();
      $close.on('click', hideNewsletter);
    }
    $('#mce-success-response').one('DOMSubtreeModified', newsletterSuccess);
  }

  function NewsletterModule() {
    $newsletterModule.find('input[type="submit"]').bind('click', function (event) {
      if (event) event.preventDefault();
      // validate_input() is a validation function I wrote, you'll have to substitute this with your own.
      //if ( validate_input($newsletterModule) ) { register($newsletterModule); }
      register($newsletterModule);
    });

    function register($newsletterModule) {
      $.ajax({
        type: $newsletterModule.attr('method'),
        url: $newsletterModule.attr('action'),
        data: $newsletterModule.serialize(),
        cache: false,
        dataType: 'json',
        contentType: "application/json; charset=utf-8",
        error: function (err) { alert("Could not connect to the registration server. Please try again later."); },
        success: function (data) {
          if (data.result != "success") {
            console.log(data);
            var msg = data.msg;
            msg = msg.split('0 - ').join('');
            $moduleMsg.html(msg);
            // Something went wrong, do something to notify the user. maybe alert(data.msg);
          } else {
            $newsletterModule.addClass('success');
            $moduleMsg.html('Thank you for signing up!');
            console.log('success');
            // It worked, carry on...
          }
        }
      });
    }
  }

  function newsletterSuccess() {
    $('.mc-form-container').hide();
    $newsletter.delay(2000).slideUp();
    Cookies.set('newsletter', 'closed', { expires: 7 });
  }

  function hideNewsletter() {
    $newsletter.slideUp();
    Cookies.set('newsletter', 'closed', { expires: 7 });
  }

  return Newsletter;
})();

theme.Search = (function () {

  const $nav_search = $('.nav-search'),
    $body = $('body'),
    $close_search = $('.close-search'),
    $overlay = $('#body-overlay');

  var $search_form, $search_input;

  if ($('#search-form').length) {
    $search_form = $('#search-form');
    $search_input = $search_form.find('input[type="search"]');
    Search();
  }

  function Search() {
    console.log('search init');
    $nav_search.on('click', toggleSearchForm);
    $close_search.on('click', closeSearch);
    $overlay.on('click', closeSearch);
  }

  function closeSearch() {
    //$('.bc-sf-search-suggestion-wrapper').fadeOut(200);
    $body.removeClass('search-active');
  }

  function toggleSearchForm(e) {
    e.preventDefault();
    $body.toggleClass('search-active').removeClass('mobile-menu-shown');
    if ($body.hasClass('search-active')) {
      $search_input.focus();
      //$('.bc-sf-search-suggestion-wrapper').fadeIn(200);
    } else {
      //$('.bc-sf-search-suggestion-wrapper').fadeOut(200);
    }
    $('.bc-sf-search-suggestion').bind("DOMSubtreeModified", function () {
      console.log('changed');
      //setMaxHeight();
    });
    //$search_form.toggle();
  }

  function setMaxHeight() {
    var mh = $window.height() - $('.bc-sf-search-suggestion').position().top;
    $('.bc-sf-search-suggestion').css('max-height', mh);
  }

  return Search;
})();

theme.FeaturedCollectionProducts = (function () {

  const $window = $(window);

  var $c = $('.featured-collection-products');
  if ($c.length) {
    FeaturedCollectionProducts();
  }

  function FeaturedCollectionProducts() {
    console.log('featured collection products');
    $slick_slider = $c;
    settings = {
      dots: true,
      infinite: false,
      arrows: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true
          }
        }
      ]
    }
    //$slick_slider.slick(settings);

    // reslick only if it's not slick()
    $(window).on('resize', function () {
      if ($(window).width() > 1024) {
        if ($slick_slider.hasClass('slick-initialized')) {
          //$slick_slider.slick('unslick');
        }
        return true;
      } else {
        if (!$slick_slider.hasClass('slick-initialized')) {
          //return $slick_slider.slick(settings);
        }
      }


    });

    $window.trigger('resize');

  }

  return FeaturedCollectionProducts;
})();


/*================ Modules ================*/
/**
 * Scroll Reveal Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Scroll Reveal module
 *
 * @namespace scrollReveal
 */

theme.scrollReveal = (function () {
  var $scrollReveal = $('.scroll-reveal');

  if (!$scrollReveal.length || $('#press').length) {
    return;
  }

  if ($('body').hasClass('template-blog')) {
    var slideUp = {
      distance: '25%',
      origin: 'bottom',
      opacity: 0,
      reset: false,
      duration: 1000
    };
  } else {
    var slideUp = {
      opacity: 0,
      reset: false,
      duration: 1000
    };
  }


  ScrollReveal().reveal('.scroll-reveal', slideUp);

  console.log('scroll reveal');

})();

/**
 * Slick Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Slick module
 *
 * @namespace slick
 */

theme.slick = (function () {
  var $slick = $('.slick');

  if (!$slick.length) {
    return;
  }

  $slick.slick({ dots: true, arrows: false });

})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $('#AddressNewForm'),
    $account_addresses_content = $('.account-addresses-content'),
    $account_addresses_saved = $('.account-addresses-saved'),
    $main_account_buttons = $('.main-account-buttons');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function () {
    $newAddressForm.toggleClass('hide');
    $account_addresses_content.toggle();
    $('.account-buttons').toggle();
  });

  $('.address-edit-toggle').on('click', function () {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
    $main_account_buttons.toggle();
    $('.address-entry').toggle();
    $account_addresses_saved.toggle();
  });

  $('.address-delete').on('click', function () {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Press Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Press template.
 *
 * @namespace press
 */

theme.customerLogin = (function () {
  var config = {
    press: 'press',
    body: 'body'
  };


  if (!$('#' + config.press).length) {
    return;
  } else {
    console.log($(config.body).attr('id'))
    console.log('equals press')
    masonry();
    pressSlideshow();
  }

  function pressSlideshow() {
    $('[data-fancybox]').fancybox({
      afterShow: function (instance, current) {
        $slick = $('.fancybox-stage .slick').slick({
          centerMode: true,
          infinite: false,
          arrows: false,
          variableWidth: true,
          dots: true
        });

        $('.slick-slide').click(function () {
          $slick.slick('slickGoTo', $(this).index());
        });
      }
    })
  }

  function masonry() {
    let $grid = $('.grid');
    $grid.masonry({
      horizontalOrder: true
    });
    $grid.imagesLoaded().progress(function () {
      $grid.masonry('layout');
    });
    $grid.imagesLoaded(function () {

    });
    var isLoaded = false;
    $grid.masonry('on', 'layoutComplete', function () {
      if (!isLoaded) {
        var slideUp = {
          distance: '25%',
          origin: 'bottom',
          opacity: 0,
          reset: false,
          duration: 500
        };

        isLoaded = true;
        ScrollReveal().reveal('.scroll-reveal', slideUp);
      }
    });
  }

})();



$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);


  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  if ($('.rellax').length > 0) {
    var rellax = new Rellax('.rellax', {
      center: true
    });
  }

  if ($('.parent-nav').length > 0) {
    $('.parent-nav ul').slideUp(0);
    $('.parent-nav.open ul').slideDown(0);
    $('.parent-nav').on('click', function () {
      $(this).toggleClass('open');
      $(this).find('ul').slideToggle();
      $(this).find('span').toggleClass('up');
    });
    $('.parent-nav ul a').on('click', function (e) {
      e.stopPropagation();
    });
  }

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

} /* end 2026-10-13 guard */
